import { render, staticRenderFns } from "./SubscriptionButton.vue?vue&type=template&id=58fb8d4d&scoped=true&"
import script from "./SubscriptionButton.vue?vue&type=script&lang=js&"
export * from "./SubscriptionButton.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionButton.vue?vue&type=style&index=0&id=58fb8d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb8d4d",
  null
  
)

export default component.exports